import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-dropdown', 'close', 'Sulge hüpikaken');
Labels.set('ui-dropdown', 'closeLang', 'Sulge keele valik');
Labels.set('ui-dropdown', 'openLang', 'Ava keele valik');

Labels.set('ui-dropdown', 'eng', 'Inglise');
Labels.set('ui-dropdown', 'est', 'Eesti');
Labels.set('ui-dropdown', 'lat', 'Vene');
